import { CmsObjectWithDefault } from '@components/Cms/types';

export type WhatsAppFormCmsKey =
    | 'Title'
    | 'Subtitle'
    | 'CountryCodeLabel'
    | 'PhoneNumberLabel'
    | 'PhoneNumberPlaceholder'
    | 'CompleteCaptcha'
    | 'InvalidPhone'
    | 'ContinueButtonText'
    | 'TermsDisclaimer'
    | 'ErrorMessage';

/**
 * CMS strings for WhatsApp form
 */
export const WhatsAppFormCmsWithDefault: CmsObjectWithDefault<WhatsAppFormCmsKey> = {
    Title: {
        cmsId: 417917,
        defaultTranslation: 'Enter your WhatsApp number',
    },
    Subtitle: {
        cmsId: 421373,
        defaultTranslation:
            'After linking a WhatsApp phone number to your account, you can use it to sign in to Agoda.',
    },
    CountryCodeLabel: {
        cmsId: 174323, // Reusing existing ID from CountryCodeSelectorCms
        defaultTranslation: 'Country code',
    },
    PhoneNumberLabel: {
        cmsId: 289854, // Reusing existing ID from PhoneNumberInputCms
        defaultTranslation: 'Phone number',
    },
    PhoneNumberPlaceholder: {
        cmsId: 68691, // Reusing existing ID from PhoneNumberInputCms
        defaultTranslation: '123',
    },
    CompleteCaptcha: {
        cmsId: 67538, // Reusing existing ID from CaptchaFormInputCms
        defaultTranslation: 'Please complete the CAPTCHA verification.',
    },
    InvalidPhone: {
        cmsId: 127009, // Reusing existing ID from PhoneNumberInputCms
        defaultTranslation: 'Please enter a valid phone number.',
    },
    ContinueButtonText: {
        cmsId: 208940, // Reusing existing ID from ProfileFormCmsWithDefault
        defaultTranslation: 'Continue',
    },
    ErrorMessage: {
        cmsId: 188020, // Reusing existing ID from ErrorMessageCms
        defaultTranslation: 'Something went wrong. Please try again.',
    },
    TermsDisclaimer: {
        cmsId: 421372,
        defaultTranslation: 'By proceeding, you agree to receive an OTP via WhatsApp',
    },
};
